import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PunterBarComponent } from './punter-bar.component';
import { SharedModule } from '../shared/shared.module';
import { LogoutConfirmationComponent } from './logout-confirmation/logout-confirmation.component';
import { PayinComponent } from './payin/payin.component';
import { PayoutComponent } from './payout/payout.component';
import { FundsDialogComponent } from './funds-dialog/funds-dialog.component';
import { TransactionListComponent } from './+transaction-list/transaction-list.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [PunterBarComponent, LogoutConfirmationComponent, PayinComponent, PayoutComponent, FundsDialogComponent,
    TransactionListComponent],
  exports: [PunterBarComponent]
})
export class PunterBarModule {
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/punter-bar.module.ts